import { i18n } from "@lingui/core"

import { Company } from "./company"
import { Representative } from "./representative"
import { Product } from "./product"
import { AssetMatchBrand } from "./asset-match-brand"
import {
    AssetType,
    PositionType,
} from "./asset"
import {PaginationInfo} from "./commons/paginated-response";
import {ContractDetailItem, ContractType} from "./contract";
import {OrderType} from "./commons/search-filter";

export interface BrandRequisite
{
    id: string
    lastUpdate: Date
    preferredContractTypes: any //TODO è un <ContractType, booleano> non ho idea di come mapparlo
    preferredAssetType: AssetType
    minGla: number
    maxGla: number
    minLandArea: number
    maxLandArea: number
    maxPrice: number
    positionType: PositionType
    shopWindows: boolean
    singleLevel: boolean
    airConditioning: boolean
    parkingSlots: boolean
    isPriorityRequisite: boolean
}

export interface BrandRequisiteSet
{
    id: string
    creationDate: Date
    requisites: BrandRequisite[]
}

export interface BrandPriority
{
    id: string
    name: string
    region: string
    city: string | null // Se null, bisogna considerare tutte le città nella regione
    street: string
    requisiteOverrides: BrandRequisite
    creationDate: string // date
    brand: Brand
    priority: string
}

export interface Brand
{
    id: string
    name: string
    logo: string
    creationDate: Date
    lastUpdate: Date
    company: Company
    products: Product[]
    contracts: ContractDetailItem[]
    activeContractsCount: number
    representatives: Representative[]
    matches: AssetMatchBrand[]
    matchVisibility: boolean
    requisites: BrandRequisiteSet
    brandPriority: BrandPriority[]
}


export interface CreateBrandRequest {
    name: string,
    company: string
}

export interface CreateBrandResponse {
    id: string
}

export interface BrandPriorityResponse {
    items: BrandPriority[]
    pagination: PaginationInfo
}


export enum PriorityLevel
{
    URGENTE="URGENTE",
    ALTA="ALTA",
    NORMALE="NORMALE",
    BASSA="BASSA",
}

export class PriorityLevelTranslations
{
    URGENTE = /*i18n*/i18n._({id: "enums.priority-level.URGENTE", message: "Urgente"})
    ALTA = /*i18n*/i18n._({id: "enums.priority-level.ALTA", message: "Alta"})
    NORMALE = /*i18n*/i18n._({id: "enums.priority-level.NORMALE", message: "Normale"})
    BASSA = /*i18n*/i18n._({id: "enums.priority-level.BASSA", message: "Bassa"})
}

export class CompatibilityTranslations
{
    HIGH = /*i18n*/i18n._({id: "compatibility.HIGH", message: "Alta"})
    MEDIUM = /*i18n*/i18n._({id: "compatibility.MEDIUM", message: "Media"})
    TO_CHECK = /*i18n*/i18n._({id: "compatibility.TO_CHECK", message: "Da verificare"})
    LOW = /*i18n*/i18n._({id: "compatibility.LOW", message: "Bassa"})
}

export interface CreateBrandPriorityRequest{
    region: string | null
    city: string | null
    street: string | null
    brand: string
    name: string | null
    requisiteOverrides: any //Qua ci va BrandRequisite ma non devo usare tutti i campi
    priority: PriorityLevel | null
}

export interface SearchMatchRequest {
    pageSize: number
    pageId: number
    orderType: null
    orderBy: null
    name: string | null
    region: string | null
    place: string | null
    street: string | null
    positionType: PositionType | null
    assetType: AssetType | null
    contractType: ContractType | null
    minGla: number | null
    maxGla: number | null
    maxPrice: number | null
    shopWindows: boolean | null
    airConditioning: boolean | null
    parkingSlots: boolean | null
    singleLevel: boolean | null
}

export interface SearchPriorityMatch {
    pageSize: number
    pageId: number
    orderType: OrderType | null
    orderBy: string | null
    priorityId: string | null
}

export interface ContractsBrandRequest {
    pageSize: number
    pageId: number
    orderType: OrderType | null
    orderBy: string | null
    brandId: string
}
